<template>

    <div class="section mt-1">
        <div class="tab-container-1">
            <nav class="pill-tabs" aria-label="Member Categories">
                <button class="pill-tab" :class="{ active: wing == 1 }" @click="getMembersList(1)" type="button">
                    {{$t('wisdom')}} {{ unit.wisdom_count }}
                </button>
                <button class="pill-tab" :class="{ active: wing == 2 }" @click="getMembersList(2)" type="button">
                    {{ $t('youth') }} {{ unit.youth_count }}
                </button>
                <button class="pill-tab" :class="{ active: wing == 3 }" @click="getMembersList(3)" type="button">
                    {{ $t('students') }} {{ unit.students_count }}
                </button>
                <button class="pill-tab" :class="{ active: wing == 4 }" @click="getMembersList(4)" type="button">
                    {{ $t('women') }} {{ unit.women_count }}
                </button>
                <button class="pill-tab" :class="{ active: wing == 5 }" @click="getMembersList(5)" type="button">
                    {{ $t('balavedi') }} {{ unit.balavedi_count }}
                </button>
                <button class="pill-tab" :class="{ active: wing == 6 }" @click="getMembersList(6)" type="button">
                    {{ $t('girls') }} {{ unit.girls_count }}
                </button>
            </nav>
        </div>
    </div>
    <!-- Action Buttons Section -->
    <div class="section pt-0 mt-0">
        <div class="action d-flex flex-wrap gap-2">
            <router-link :to="'/org/4/' + unit_id_ + '/members-list-payments'"
                class="btn btn-success btn-sm" v-if="permissions && permissions.members_payments">
                <ion-icon name="card-outline" class="me-1"></ion-icon>
                {{ $t('click_here_to_view_and_pay_fee_details') }}
            </router-link>
        </div>
    </div>
    <div class="section pt-0 mt-1">
        <div class="action d-flex flex-wrap gap-2">
            <a :href="permissions.membership_report_link" target="_blank" class="btn btn-danger btn-sm" v-if="permissions && permissions.membership_report_link">
                <ion-icon name="card-outline" class="me-1"></ion-icon>
                {{ $t('click_here_to_download_membership_report') }}
            </a>
        </div>
    </div>
    <div class="section pt-0 mt-1">
        <div class="action d-flex flex-wrap gap-2">
            <router-link  class="btn btn-primary btn-sm" :to="'/org/4/' + unit_id_ + '/cons-report'" v-if="permissions && permissions.membership_consolidated_report">
                <ion-icon name="card-outline" class="me-1"></ion-icon>
                {{ $t('click_here_to_consolidated_report') }}
            </router-link>
        </div>
    </div>
    <div class="section pt-0 mt-1">
        <div class="action d-flex flex-wrap gap-2">
            <a :href="permissions.membership_form_bulk_link" target="_blank" class="btn btn-warning btn-sm" v-if="permissions && permissions.membership_form_bulk_link">
                <ion-icon name="card-outline" class="me-1"></ion-icon>
                {{ $t('click_here_to_bulk_download_expatriate_prints') }}
            </a>
        </div>
    </div>
    
    <!-- AddMemberModel -->
    <div class="modal fade action-sheet" id="addMemberModel" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" v-if="!add_admin">{{ $t('edit_member') }}</h5>
                    <h5 class="modal-title" v-if="add_admin">{{ $t('add_member') }}</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        
                        <Form @submit="addMember" :validation-schema="schema">
                            <div class="form-group basic">
                                <label class="label" for="Name">{{ $t('name') }}</label>
                                <Field name="name" type="text" :disabled="!add_admin" class="form-control" id="name"
                                    v-model="name" :placeholder="$t('enter_name')" autocomplete="off" />
                                <ErrorMessage name="name" class="error-feedback" />
                            </div>
                             <div class="form-group" v-if="!message">
                                <div v-if="!message" class="error-feedback">
                                    <b>{{permissions.member_mobile_edit_text}}</b>
                                </div>
                            </div>
                            <div class="form-group" v-if="message">
                                <div v-if="message" class="error-feedback">
                                    {{ $t(message) }}
                                </div>
                            </div>
                            <div class="form-group basic">
                                <div class="input-wrapper row">
                                    <label class="label" for="country_code">{{ $t('mobile_number') }}</label>
                                    <div class="form-group" style="width:30% !important;">
                                        <div class="input-wrapper">
                                            <Field as="select" class="form-control custom-select" v-model="country_code"
                                                name="country_code" :disabled="!add_admin" id="select4"
                                                @change="onChangeCountryCode($event)">
                                                <option v-for="item in country_code_list" :value="item.item_value"
                                                    v-bind:key="item.item_value">
                                                    {{ item.name }}</option>
                                            </Field>
                                        </div>
                                    </div>
                                    <div class="form-group mobile-field" style="width:68% !important; margin-left: 2%;">
                                        <div class="input-wrapper">
                                            <Field name="mobile_number" type="number" id="mobile_number"
                                                class="form-control" :disabled="!add_admin || !mobile_editable" placeholder=""
                                                autocomplete="off" v-model="mobile_number"
                                                oninput="javascript: this.value.replace(/[\s\/]/g,''); if(this.value.charAt(0) == 0){ this.value = this.value.slice(1, 11); } if(this.value.length > 10) { this.value = this.value.slice(0, 10);} " />
                                        </div>
                                    </div>
                                    <ErrorMessage name="mobile_number" class="error-feedback" />
                                </div>
                            </div>
                            <div class="form-group basic">
                                <div class="input-wrapper row">
                                    <label class="label" for="country_code">{{ $t('whatsapp_number') }}</label>
                                    <div class="form-group boxed" style="width:30% !important;">
                                        <div class="input-wrapper">
                                            <Field as="select" :disabled="!add_admin" class="form-control custom-select"
                                                v-model="country_code_whatsapp" name="country_code_whatsapp"
                                                id="select4">
                                                <option v-for="item in country_code_list" :value="item.item_value"
                                                    v-bind:key="item.item_value">
                                                    {{ item.name }}</option>
                                            </Field>
                                        </div>
                                    </div>
                                    <div class="form-group boxed mobile-field"
                                        style="width:68% !important; margin-left: 2%;">
                                        <div class="input-wrapper">
                                            <Field name="whatsapp_number" type="number" id="whatsapp_number"
                                                class="form-control" :disabled="!add_admin" placeholder=""
                                                autocomplete="off" v-model="whatsapp_number"
                                                oninput="javascript: this.value.replace(/[\s\/]/g,''); if(this.value.charAt(0) == 0){ this.value = this.value.slice(1, 11); } if(this.value.length > 10) { this.value = this.value.slice(0, 10);} " />
                                        </div>
                                    </div>
                                    <ErrorMessage name="whatsapp_number" class="error-feedback" />
                                </div>
                            </div>
                            <!-- <div class="form-group basic">
                                <label class="label" for="stay">Stay <span class="mal-text">(താമസം)</span></label>
                                <div class="form-group boxed">
                                    <div class="input-wrapper mal-text">
                                        <Field as="select" class="form-control custom-select" v-model="stay" name="stay"
                                            id="select4">
                                            <option value>താമസം സെലക്ട് ചെയ്യുക</option>
                                            <option value="native">നാട്ടിൽ</option>
                                            <option value="outof_state">കേരളത്തിന് പുറത്ത്</option>
                                            <option value="outof_country">ഇന്ത്യക്കു പുറത്ത്</option>

                                        </Field>
                                    </div>
                                </div>
                                <ErrorMessage name="stay" class="error-feedback" />
                            </div>   -->
                            <div class="form-group basic">
                                <label class="label" for="wing">{{ $t('wing') }}</label>
                                <div class="input-wrapper">
                                    <Field as="select" class="form-control custom-select" v-model="wing" name="wing"
                                        id="select4">
                                        <option selected>{{ $t('select_wing') }}</option>
                                        <option value="1">{{ $t('wisdom') }}</option>
                                        <option value="2">{{ $t('youth') }}</option>
                                        <option value="3">{{ $t('students') }}</option>
                                        <option value="4">{{ $t('women') }}</option>
                                        <option value="5">{{ $t('balavedi') }}</option>
                                        <option value="6">{{ $t('girls') }}</option>

                                    </Field>
                                </div>
                                <ErrorMessage name="wing" class="error-feedback" />
                            </div>

                            <div class="form-group basic">
                                <button type="submit" class="btn btn-primary btn-block btn-lg" :disabled="loading"
                                    v-if="editable || add_admin">
                                    <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                                    <span>{{ $t('save') }}</span>
                                </button>
                                <button type="button" class="btn btn-primary btn-block btn-lg"
                                    v-if="!editable && !add_admin" @click="closeAddMemberModel">{{ $t('close') }}</button>
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- DeleteMemberModel -->
    <div class="modal fade action-sheet" id="deleteMemberModel" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $t('delete_member') }}</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <div class="form-group" v-if="message_delete">
                            <div v-if="message_delete" class="error-feedback">
                                {{ message_delete }}
                            </div>
                        </div>
                        <div class="form-group basic" v-if="!delete_type">
                            <label class="label" for="stay"><span class="mal-text">{{ $t('reason_to_delete') }}</span></label>
                            <div class="form-group boxed">
                                <div class="input-wrapper mal-text">
                                    <select as="select" class="form-control custom-select" v-model="reason_to_delete"
                                        name="stay" id="select4" @change="adminDeleteChange($event)">
                                        <option value>{{ $t('reason_to_delete') }}</option>
                                        <option value="മരണപ്പെട്ടു">{{ $t('died') }}</option>
                                        <option value="Duplicate Entry">{{ $t('duplicate_entry') }}</option>
                                        <option value="ഇനി മെമ്പർഷിപ്പ് വേണ്ട എന്ന് അദ്ദേഹം പറഞ്ഞു">
                                            {{ $t('no_longer_needed') }}</option>
                                        <option value="മെമ്പർഷിപ്പ്  ഒഴിവാക്കാൻ ശാഖാ കമ്മിറ്റി തീരുമാനിച്ചു">
                                            {{ $t('no_longer_needed_2') }}</option>
                                        <option value="ആദർശപരമായി നമ്മോട് ഇപ്പോൾ  താൽപര്യമില്ല.">
                                            {{ $t('no_longer_needed_3') }}</option>
                                        <option value="സാമ്പത്തിക മേഖലയിൽ ഉള്ള പ്രശ്നങ്ങൾ">{{ $t('financial_issues') }}</option>
                                        <option value="നമ്മുടെ പ്രസ്ഥാനത്തിന് യോജിക്കാത്ത സ്വഭാവ പരമായ പ്രശ്നങ്ങൾ.">
                                            {{ $t('character_issues') }}</option>
                                        <option value="കഴിഞ്ഞതവണ അബദ്ധത്തിൽ ചേർത്തിയതാണ്. നമ്മുടെ ആദർശമല്ല">{{ $t('last_time_added_by_mistake') }}</option>
                                        <option value="Other">{{ $t('other_reason') }} </option>
                                    </select>
                                </div>
                                <input type="hidden" v-model="deletable_id" />
                            </div>
                        </div>
                        <div class="form-group basic" v-if="delete_others">
                            <label class="label" for="Name"><span class="mal-text">{{ $t('reason_to_delete') }}</span></label>
                            <div class="form-group boxed">
                                <Field name="name" type="text" class="form-control" v-model="delete_other_text"
                                    :placeholder="$t('reason_to_delete_explain')" autocomplete="off" />
                            </div>
                        </div>

                        <div class="form-group basic">
                            <button type="button" @click="memberDelete()" class="btn btn-primary btn-block btn-lg"
                                :disabled="loading">
                                <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                                <span v-if="!delete_type">{{ $t('delete') }}</span>
                                <span v-else-if="delete_type == 'undo'">{{ $t('cancel') }}</span>
                                <span v-else-if="delete_type == 'approved'">{{ $t('approve_and_delete') }}</span>
                                <span v-else>{{ $t('reject_and_restore') }}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- * AddMemberModel -->
    <!-- verificationModelModel -->
    <div class="modal fade action-sheet" id="verificationModel" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $t('member_verification') }}</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content" v-if="currentUser.user_level == 1 && !verification_report">
                        <div class="form-group" v-if="verification_message">
                            <div v-if="verification_message" class="error-feedback">
                                {{ verification_message }}
                            </div>
                        </div>
                        <div class="form-group basic">
                            <label class="label" for="stay"><span>{{ $t('verification_status') }}</span></label>
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <select as="select" class="form-control custom-select" v-model="verification_status"
                                        name="stay" id="select4">
                                        <option value>{{ $t('verification_status') }}</option>
                                        <option value="Y">{{ $t('verified') }}</option>
                                        <option value="N">{{ $t('not_verified') }}</option>
                                    </select>
                                </div>
                                <input type="hidden" v-model="member_id" />
                            </div>
                        </div>
                        <div class="form-group basic" v-if="verification_status == 'N'">
                            <label class="label" for="stay"><span>{{ $t('not_verified_reason') }}</span></label>
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <select as="select" class="form-control custom-select"
                                        v-model="not_verification_status" name="stay" id="select4">
                                        <option value>{{ $t('select_reason') }}</option>
                                        <option v-for="item in verification_status_list" :value="item.id"
                                            v-bind:key="item.id">
                                            {{ item.name }}</option>
                                    </select>
                                </div>
                                <input type="hidden" v-model="member_id" />
                            </div>
                        </div>
                        <div class="form-group basic">
                            <label class="label" for="Remarks"><span>{{ $t('remarks') }}</span></label>
                            <div class="form-group boxed">
                                <Field name="verification_remark" type="text" class="form-control"
                                    v-model="verification_remark" placeholder="Remarks" autocomplete="off" />
                            </div>
                        </div>

                        <div class="form-group basic">
                            <button type="button" @click="memberVerify()" class="btn btn-primary btn-block btn-lg"
                                :disabled="loading">
                                <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                                <span>{{ $t('save') }}</span></button>
                        </div>
                    </div>
                    <div class="action-sheet-content" v-if="currentUser.user_level <= 4 && verification_report">
                        <div class="form-group basic">
                            <label class="label mal-text" for="stay"><span>{{ $t('verification_status') }}</span></label>
                            <h4 class="mal-text text-success" v-if="verification_status == 'Y'">{{ $t('verified_completed') }}</h4>
                            <h4 class="mal-text text-danger" v-if="verification_status == 'N'">{{ $t('verified_not_completed') }}</h4>
                        </div>
                        <div class="form-group basic" v-if="verification_status == 'N' && not_verification_status">
                            <label class="label mal-text" for="stay"><span>{{ $t('not_verified_reason') }}</span></label>
                            <h4 class="mal-text text-danger" v-if="not_verification_status_">
                                {{ not_verification_status_ }}</h4>
                        </div>
                        <div class="form-group basic" v-if="verification_remark">
                            <label class="label mal-text" for="Remarks"><span>{{ $t('remark') }}</span></label>
                            <h4 class="mal-text text-primary">{{ verification_remark }}</h4>
                        </div>

                        <div class="form-group basic">
                            <button type="button" class="btn btn-primary btn-block btn-lg"
                                @click="closeVerificationModel">
                                <span>{{ $t('close') }}</span></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- lajna membership -->
    <div class="modal fade action-sheet" id="lajnaMemberModel" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $t('lajna_membership') }}</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content" v-if="currentUser.user_level == 1">
                        <div class="form-group basic">
                            <label class="label" for="stay"><span>{{ $t('lajna_member_status') }}</span></label>
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <select as="select" class="form-control custom-select" v-model="lajna_member"
                                        name="lajna_member" id="select4">
                                        <option value="N">{{ $t('not_member') }}</option>
                                        <option value="Y">{{ $t('is_member') }}</option>
                                    </select>
                                </div>
                                <input type="hidden" v-model="member_id" />
                            </div>
                        </div>
                        <div class="form-group basic">
                            <button type="button" @click="memberLajnaMamberSave()"
                                class="btn btn-primary btn-block btn-lg" :disabled="loading">
                                <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                                <span>{{ $t('save') }}</span></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
        <div class="modal fade action-sheet" id="formCollectedModel" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $t('form_collection') }}</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <div class="form-group basic">
                            <label class="label" for="stay"><span>{{ $t('status') }}</span></label>
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <select as="select" class="form-control custom-select" v-model="form_collected"
                                        name="form_collected" id="select4">
                                        <option value="Y">{{ $t('collected') }}</option>
                                        <option value="N">{{ $t('not_collected') }}</option>
                                    </select>
                                </div>
                                <input type="hidden" v-model="member_id" />
                            </div>
                        </div>
                        <div class="form-group basic">
                            <button type="button" @click="formCollectedSave()"
                                class="btn btn-primary btn-block btn-lg" :disabled="loading">
                                <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                                <span>{{ $t('save') }}</span></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade action-sheet" id="addNerpathamModel" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" v-if="!add_nerpatham">{{ $t('subscription') }}</h5>
                    <h5 class="modal-title" v-if="add_nerpatham">{{ $t('subscription') }}</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <Form @submit="addNerpatham">
                            <div class="form-group basic">
                                <label class="label" for="stay"><span>{{ $t('is_subscriber') }}</span></label>
                                <div class="form-group boxed">
                                    <div class="input-wrapper">
                                        <select as="select" class="form-control custom-select" v-model="isSubscriber"
                                            name="isSubscriber" id="select4">
                                            <option value="Y">{{ $t('yes') }}</option>
                                            <option value="N">{{ $t('no') }}</option>
                                        </select>
                                    </div>
                                    <input type="hidden" v-model="member_id" />
                                </div>
                            </div>

                            <div class="form-group basic">
                                <label class="label" for="receipt_number"><span>{{ $t('receipt_number') }}</span></label>
                                <div class="form-group boxed">
                                    <div class="input-wrapper">
                                        <div class="form-group boxed">
                                            <Field name="receipt_number" type="text" class="form-control"
                                                v-model="receipt_no" placeholder="Receipt Number" autocomplete="off" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group basic" v-if="isSubscriber == 'Y'">
                                <label class="label" for="subscription_number"><span>{{ $t('subscription_number') }}</span></label>
                                <div class="form-group boxed">
                                    <div class="input-wrapper">
                                        <div class="form-group boxed">
                                            <Field name="subscription_number" type="text" class="form-control"
                                                v-model="subscription_no" placeholder="Subscription Number"
                                                autocomplete="off" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group" v-if="message">
                                <div v-if="message" class="error-feedback">
                                    {{ message }}
                                </div>
                            </div>

                            <div class="form-group basic">
                                <button type="submit" class="btn btn-primary btn-block btn-lg" :disabled="loading"
                                    v-if="editable || add_admin">
                                    <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                                    <span>Save</span></button>
                                <button type="button" class="btn btn-primary btn-block btn-lg"
                                    v-if="!editable && !add_admin" @click="closeAddAdminModel">{{ $t('close') }}</button>
                            </div>
                            </Form>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Youth Conference -->
    <div class="modal fade action-sheet" id="addAbroadModel" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $t('current_status') }}</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <Form @submit="addAbroad">
                            <div class="form-group basic">
                                <label class="label" for="stay"><span>{{ $t('status') }}</span></label>
                                <div class="input-wrapper">
                                    <select as="select" class="form-control custom-select" v-model="isAbroad"
                                        name="isAbroad" id="select4">
                                        <option value=''>---{{ $t('select') }}---</option>
                                        <option value="നാട്ടിൽ ഉണ്ട് ആക്റ്റീവ് ആണ്">{{ $t('active_in_native') }}</option>
                                        <option value="നാട്ടിൽ ഉണ്ട് ആക്റ്റീവ് അല്ല">{{ $t('not_active_in_native') }}
                                        </option>
                                        <option value="വിദേശത്ത് ആണ്">{{  $t('abroad') }}</option>
                                        <option value="ഒരു വിവരവും ഇല്ല">{{ $t('no_information') }}</option>
                                    </select>
                                </div>
                                <input type="hidden" v-model="member_id" />
                            </div>
                            <div class="form-group basic" v-if="isAbroad == 'വിദേശത്ത് ആണ്'">
                                <label class="label" for="stay"><span>{{ $t('country')}}</span></label>
                                <div class="input-wrapper">
                                    <select as="select" class="form-control custom-select" v-model="abroadCountry"
                                        name="abroadCountry" id="select4">
                                        <option v-for="item in country_list" :value="item.item_value"
                                            v-bind:key="item.item_value">
                                            {{ item.name }}</option>
                                    </select>
                                </div>
                                <input type="hidden" v-model="member_id" />
                            </div>

                            <div class="form-group basic" v-if="isAbroad == 'വിദേശത്ത് ആണ്'">
                                <label class="label" for="abroadPlace"><span>{{ $t('place')}}</span></label>
                                <div class="input-wrapper">
                                    <Field name="abroadPlace" type="text" class="form-control" v-model="abroadPlace"
                                        placeholder="Place" autocomplete="off" />
                                </div>
                            </div>
                            <div class="form-group basic" v-if="isAbroad == 'വിദേശത്ത് ആണ്'">
                                <label class="label" for="abroadMobile"><span>{{ $t('forign_mobile')}}</span></label>
                                <div class="input-wrapper">
                                    <Field name="abroadMobile" type="text" class="form-control" v-model="abroadMobile"
                                        placeholder="Mobile" autocomplete="off" />
                                </div>
                            </div>
                            <div class="form-group" v-if="message">
                                <div v-if="message" class="error-feedback">
                                    {{ message }}
                                </div>
                            </div>

                            <div class="form-group basic">
                                <button type="submit" class="btn btn-primary btn-block btn-lg" :disabled="loading"
                                    v-if="currentUser.user_level <= 4">
                                    <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                                    <span>Save</span></button>
                                <button type="button" class="btn btn-primary btn-block btn-lg"
                                    v-if="currentUser.user_level > 4" @click="closeAddAdminModel">{{ $t('close') }}</button>
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- * verificationModel -->
    <!-- <div class="section pt-1 mt-1" v-if="unit.new_member_add == 'Y'">
        <button type="button" class="btn btn-primary btn-sm me-1 mb-1" @click="adminAdd" v-if="editable">
            Members Directory
        </button>
        <button type="button" class="btn btn-danger btn-sm me-1 mb-1" @click="adminAdd" v-if="editable">
            Unit Clustors
        </button>
    </div> -->

    <!-- <div class="section pt-1 mt-1 d-flex flex-wrap gap-2 text-center" v-if="unit.new_member_add == 'Y'">
        <router-link :to="'org/4/'+unit.id+'/members-directory'" class="btn btn-primary btn-sm flex-fill"
            v-if="editable">
            Members Directory
        </router-link>
        <router-link :to="'org/4/'+unit.id+'/clustors-list'" class="btn btn-danger btn-sm flex-fill"
            v-if="editable">
            Unit Clusters
        </router-link>
        <router-link :to="'org/4/'+unit.id+'/data-collection'" class="btn btn-info btn-sm flex-fill"
            v-if="editable">
            Unit Data Collection
        </router-link>
    </div> -->

    <!-- <div class="section-heading">
        <div class="listview-title mt-0 custom-title">
            List </div><br>
    </div> -->

    <!-- <div class="section mt-2 mb-2" v-if="trash_list.length && !loading">
        <div class="card">
            <div class="table-responsive">
                <table class="table">
                    <thead>
                        <tr>
                            <th scope="col" class="mal-text text-center deleted-info">സെപ്റ്റംബർ 15ന് ശേഷം ഡിലീറ്റ്
                                ചെയ്തവരുടെ എണ്ണം : <strong>{{ trash_list.length }}</strong></th>
                        </tr>
                    </thead>
                </table>
            </div>
        </div>
    </div> -->
    <!-- <div class="listed-detail mt-0">
        <h4 class="text-center mt-0 mal-text" v-if="!loading_list && member_lists.length <= 0 && !unit.new_member_add">ഇതുവരെ ആരെയും
            ചേർത്തിട്ടില്ല</h4>
    </div>
    <div class="listed-detail mt-0">
        <h4 class="text-center mt-0 mal-text" v-if="!loading_list && temp_member_lists.length <= 0 && unit.new_member_add">ഇതുവരെ ആരെയും
            ചേർത്തിട്ടില്ല</h4>
    </div> -->
    <div id="search">
        <form class="search-form">
            <div class="form-group searchbox">
                <input type="text" class="form-control" :placeholder="$t('search')" v-model="search_qty"
                    @input="filteredMembers()">
                <i class="input-icon">
                    <ion-icon name="search-outline"></ion-icon>
                </i>
            </div>
        </form>
    </div>
    <div class="section text-center mt-2" v-if="loading_list">
        <div class="spinner-border text-secondary" role="status"></div>
    </div>
    <div class="section" v-if="!loading_list && unit.header_summary">
        <div class="row mt-1">
            <div class="col-12">
                <div class="stat-box">
                    <div class="title mal-text text-primary">{{ unit.header_summary_event }}<br>{{ $t('eligible') }}</div>
                    <div class="value text-dark"><span class="text-primary">{{ unit.kyc_eligible }}</span>
                    </div>
                </div>
            </div>
            <div class="col-6 mt-1">
                <div class="stat-box">
                    <div class="title mal-text text-primary">{{ $t('registered') }}</div>
                    <div class="value text-dark"><span class="text-success">{{ unit.kyc_registered }}</span>
                    </div>
                </div>
            </div>
            <div class="col-6 mt-1">
                <div class="stat-box">
                    <div class="title mal-text text-primary">{{ $t('not_registered') }}</div>
                    <div class="value text-dark"><span class="text-danger">{{ unit.kyc_not_registered }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="listview-title mt-0 mal-text text-primary" v-if="!loading_list && change_unit_members.length">{{ $t('change_unit_members') }}</div>
    <ul class="listview image-listview inset text mt-0 mb-2" v-if="!loading_list && change_unit_members.length">
        <li v-for="(member_list, index) in change_unit_members" v-bind:key="'change_' + member_list.id"
            :set="background = member_list.fillStatus <= 0 ? 'rgb(242 187 202)' : '#ffffff'"
            :style="{ 'background-color': background }">
            <a href="javascript:void(0)" class="item">
                <span class="sl-no">{{ index + 1 }}</span>
                <div class="avatar-section">
                    <a href="#">
                        <img v-if="member_list.avatar != 'member.jpg' && member_list.avatar != null"
                            :src="'https://guide.msoftit.com/' + member_list.avatar" alt="avatar" class="image">
                        <img v-if="!member_list.avatar || member_list.avatar == 'member.jpg'"
                            :src="'assets/img/sample/avatar/avatar1.png'" alt="avatar" class="image">
                        <span class="button-payment payment-verified" v-if="member_list.payment_status == 'Paid'">
                            <ion-icon name="card-outline"></ion-icon>
                        </span>
                        <!-- <span class="button verified" v-if="member_list.verified == 'Y'">
                            <ion-icon name="checkmark-outline"></ion-icon>
                        </span>
                        <span class="button not-verified" v-if="member_list.verified == 'N'">
                            <ion-icon name="close-outline"></ion-icon>
                        </span> -->
                    </a>
                </div>
                <div class="in">
                    <div class="min-width-50">
                        <b> {{ member_list.name }} </b>
                        <footer>{{ member_list.country_code }} {{ member_list.mobile }}
                            <br>
                            <span v-if="member_list.transfered_status" v-html="member_list.transfered_status"></span>
                        </footer>
                    </div>
                    <div class="progress float-right" v-if="member_list.fillStatus > 0 && member_list.verified != 'Y'"
                        :set="background_ = member_list.fillStatus >= 100 ? '#059205' : '#1a418c'">
                        <div class="progress-bar" role="progressbar"
                            :style="{ width: member_list.fillStatus + '%', background: background_ }" aria-valuenow="85"
                            aria-valuemin="0" aria-valuemax="100">{{ member_list.fillStatus }}%</div>
                    </div>
                    <div class="card-button dropdown">
                        <button type="button" class="btn btn-link btn-icon" data-bs-toggle="modal"
                            :data-bs-target="'#changeUnitActionSheet' + member_list.id" @click="showActionModel">
                            <ion-icon name="ellipsis-vertical-outline"></ion-icon>
                        </button>
                    </div>

                    <!-- Change Unit Action Sheet -->
                    <div class="modal fade action-sheet" :id="'changeUnitActionSheet' + member_list.id" tabindex="-1"
                        role="dialog">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">{{ $t('transfer_unit_actions') }}</h5>
                                </div>
                                <div class="modal-body">
                                    <ul class="action-button-list">
                                        <li v-if="permissions.members.convert_member">
                                            <a href="javascript:void(0)" class="btn btn-list" data-bs-dismiss="modal"
                                                @click="approveUnitChange(member_list)">
                                                <span>
                                                    <ion-icon name="checkmark-outline"></ion-icon> {{ $t('approve_transfer') }}
                                                </span>
                                            </a>
                                        </li>
                                        <li v-if="permissions.members.convert_member">
                                            <a href="javascript:void(0)" class="btn btn-list" data-bs-dismiss="modal"
                                                @click="rejectUnitChange(member_list)">
                                                <span>
                                                    <ion-icon name="close-outline"></ion-icon> {{ $t('reject_transfer') }}
                                                </span>
                                            </a>
                                        </li>
                                        <li v-if="this.permissions.members.call">
                                            <a :href="'tel:' + member_list.mobile" class="btn btn-list">
                                                <span>
                                                    <ion-icon name="call-outline"></ion-icon> {{ $t('call') }}
                                                </span>
                                            </a>
                                        </li>
                                        <li v-if="member_list.whatsapp && this.permissions.members.whatsapp">
                                            <a :href="'https://wa.me/' + member_list.whatsapp_country_code + member_list.whatsapp + '?text='"
                                                class="btn btn-list">
                                                <span>
                                                    <ion-icon name="logo-whatsapp"></ion-icon> {{ $t('whatsapp') }}
                                                </span>
                                            </a>
                                        </li>
                                        <li class="action-divider"></li>
                                        <li>
                                            <a href="#" class="btn btn-list text-danger" data-bs-dismiss="modal">
                                                <span>
                                                    <ion-icon name="close-outline"></ion-icon> {{ $t('cancel') }}
                                                </span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </a>
        </li>
    </ul>

    <div class="listview-title mt-0 mal-text text-danger" v-if="!loading_list && member_pending_lists.length">{{ $t('pending_members_list') }}</div>
    <ul class="listview image-listview inset text mt-0 mb-1" v-if="!loading_list && member_pending_lists.length">
        <li v-for="(member_list, index) in member_pending_lists" 
            :key="member_list.id"
            style="backgroundColor:rgba(255, 0, 0, 0.2)">
            <a href="javascript:void(0)" class="item">
                <span class="sl-no">{{ index + 1 }}</span>
                <div class="avatar-section">
                    <a href="#">
                        <img v-if="member_list.avatar != 'member.jpg' && member_list.avatar != null"
                            :src="'https://guide.msoftit.com/' + member_list.avatar" alt="avatar" class="image">
                        <img v-if="!member_list.avatar || member_list.avatar == 'member.jpg'"
                            :src="'assets/img/sample/avatar/avatar1.png'" alt="avatar" class="image">
                        <span class="button-payment payment-verified" v-if="member_list.payment_status == 'Paid'">
                            <ion-icon name="card-outline"></ion-icon>
                        </span>
                        <span class="button abroad" v-if="member_list.abroad">
                            <ion-icon name="airplane-outline"></ion-icon>
                        </span>
                        <span class="button verified" v-if="member_list.verified == 'Y'">
                            <ion-icon name="checkmark-outline"></ion-icon>
                        </span>
                        <span class="button not-verified" v-if="member_list.verified == 'N'">
                            <ion-icon name="close-outline"></ion-icon>
                        </span>
                        <!-- QHLS avatar flag removed as requested -->
                    </a>
                </div>
                <div class="in">
                    <div class="min-width-50">
                        <!-- <header>User</header> -->
                        <b> {{ member_list.name }} </b>
                        <footer>{{ member_list.country_code }} {{ member_list.mobile }}<span class="qhls-text"
                                v-if="((permissions.qhls ? permissions.qhls.view : false) && (member_list.qhls_reg == 1 || member_list.qhls_registered))">,{{
                                    unit.qhls_register_text }}</span>
                            <span v-if="member_list.kyc_status"><br>
                                {{ member_list.kyc_status_label }} : <b class="mal-text"
                                    v-bind:class="member_list.kyc_status_class">{{ member_list.kyc_status }}</b></span>
                            <span v-if="member_list.kyc_status"><br>
                                {{ member_list.kyc_status_label }} : <b class="mal-text"
                                    v-bind:class="member_list.kyc_status_class">{{ member_list.kyc_status }}</b></span>
                            <span v-if="member_list.kyc_status_2"><br>
                                {{ member_list.kyc_status_label_2 }} : <b class="mal-text"
                                    v-bind:class="member_list.kyc_status_class_2">{{ member_list.kyc_status_2 }}</b></span>
                            <span v-if="member_list.kyc_status_3"><br>
                                {{ member_list.kyc_status_label_3 }} : <b class="mal-text"
                                    v-bind:class="member_list.kyc_status_class_3">{{ member_list.kyc_status_3 }}</b></span>
                            <span v-if="member_list.kyc_status_4 && member_list.kyc_status_label_4 == 'Nerpatham'"><br>
                                {{ member_list.kyc_status_label_4 }} : <b class="mal-text"
                                    v-bind:class="member_list.kyc_status_class_4">{{ member_list.kyc_status_4 }}</b></span>
                            <span v-if="member_list.qhls_status"><br>
                                QHLS : <b class="mal-text" :class="member_list.qhls_status_class">{{ member_list.qhls_status }}</b></span>
                            <div class="form-check form-check-inline" v-if="currentUser.testing_user == 'Y5388'">
                                <input class="form-check-input" type="checkbox" :checked="member_list.verified == 'Y'"
                                    :id="'inlineCheckbox' + member_list.id" value="1"
                                    v-model="verification_check[member_list.id]"
                                    @click="verificationCheckClick(1, member_list.id)">
                                <label class="form-check-label green-tick" :for="'inlineCheckbox' + member_list.id">
                                    <ion-icon name="checkmark-outline"></ion-icon>
                                </label>
                            </div>
                            <div class="form-check form-check-inline" v-if="currentUser.testing_user == 'Y5388'">
                                <input class="form-check-input" type="checkbox"
                                    :checked="member_list.verified == 'N' && member_list.verification_status"
                                    :id="'inlineCheckbox_' + member_list.id" value="0"
                                    v-model="not_verification_check[member_list.id]"
                                    @click="verificationCheckClick(0, member_list.id)">
                                <label class="form-check-label red-cross" :for="'inlineCheckbox_' + member_list.id">
                                    <ion-icon name="close-outline"></ion-icon>
                                </label>
                            </div>
                        </footer>
                    </div>
                    <div class="progress float-right" v-if="member_list.fillStatus > 0 && member_list.verified != 'Y'"
                        :set="background_ = member_list.fillStatus >= 100 ? '#059205' : '#1a418c'">
                        <div class="progress-bar" role="progressbar"
                            :style="{ width: member_list.fillStatus + '%', background: background_ }" aria-valuenow="85"
                            aria-valuemin="0" aria-valuemax="100">{{ member_list.fillStatus }}%</div>
                    </div>
                    <div class="card-button dropdown">
                        <button type="button" class="btn btn-link btn-icon" data-bs-toggle="modal"
                            :data-bs-target="'#actionSheetInsetPending' + member_list.id" @click="showActionModel">
                            <ion-icon name="ellipsis-vertical-outline"></ion-icon>
                        </button>
                    </div>

                    <!-- Default Action Sheet Inset -->

                    <!-- Default Action Sheet Inset -->
                    <div class="modal fade action-sheet" :id="'actionSheetInsetPending' + member_list.id" tabindex="-1"
                        role="dialog">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">{{ $t('action') }}</h5>
                                </div>
                                <div class="modal-body">
                                    <ul class="action-button-list">
                                        <li v-if="this.permissions.members.restore_member">
                                            <a href="javascript:void(0)" class="btn btn-list" data-bs-dismiss="modal"
                                                @click="openRestoreDialog(member_list)">
                                                <span>
                                                    <ion-icon name="refresh-outline"></ion-icon> {{ $t('restore_member') }}
                                                </span>
                                            </a>
                                        </li>
                                        <li v-if="this.permissions.members.convert_member">
                                            <a :href="'https://wa.me/' + (member_list.whatsapp_country_code + member_list.whatsapp) +'?text=വിസ്ഡം മെമ്പർഷിപ്പിലേക്ക് സ്വാഗതം%0A%0Aവീഡിയോ കാണുക: https://youtu.be/Hqn56eiB1lA%0A%0Aവിസ്ഡം ഗൈഡ് ലിങ്ക് : guide.wisdomislam.org'" class="btn btn-list"
                                                >
                                                <span>
                                                    <ion-icon name="refresh-outline"></ion-icon>{{ $t('send_guide_link') }}
                                                </span>
                                            </a>
                                        </li>
                                        <li v-if="this.permissions.members.call">
                                            <a :href="'tel:' + member_list.mobile" class="btn btn-list">
                                                <span>
                                                    <ion-icon name="call-outline"></ion-icon> {{ $t('call') }}
                                                </span>
                                            </a>
                                        </li>
                                        <li v-if="member_list.whatsapp && this.permissions.members.whatsapp">
                                            <a :href="'https://wa.me/' + member_list.whatsapp_country_code + member_list.whatsapp + '?text='"
                                                class="btn btn-list">
                                                <span>
                                                    <ion-icon name="logo-whatsapp"></ion-icon> {{ $t('whatsapp') }}
                                                </span>
                                            </a>
                                        </li>
                                        <li v-if="this.permissions.members.edit">
                                            <a href="javascript:void(0)" @click="memberView(member_list)"
                                                class="btn btn-list" data-bs-dismiss="modal">
                                                <span>
                                                    <ion-icon name="pencil-outline"></ion-icon> {{ $t('edit') }}
                                                </span>
                                            </a>
                                        </li>
                                        <li class="action-divider"></li>
                                        <li>
                                            <a href="#" class="btn btn-list text-danger" data-bs-dismiss="modal">
                                                <span>
                                                    <ion-icon name="close-outline"></ion-icon> {{ $t('cancel') }}
                                                </span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- * Default Action Sheet Inset -->
                </div>
            </a>
        </li>
    </ul>

    <div class="listview-title mt-0 mal-text text-primary" v-if="!loading_list && member_lists.length">{{ $t('members') }}</div>
    <ul class="listview image-listview inset text mt-0 mb-1" v-if="!loading_list && member_lists.length">
        <li v-for="(member_list, index) in member_lists" 
            :key="member_list.id"
            :style="{
                backgroundColor: 
                    member_list.fillStatus == 0
                        ? 'rgba(255, 0, 0, 0.2)'     // light red
                        : ((member_list.fillStatus > 0 && member_list.fillStatus < 100) || member_list.payment_status != 'Paid'
                            ? 'rgba(255, 255, 0, 0.2)' // light yellow
                            : '#ffffff')               // white
            }">
            <a href="javascript:void(0)" class="item">
                <span class="sl-no">{{ index + 1 }}</span>
                <div class="avatar-section">
                    <a href="#">
                        <img v-if="member_list.avatar != 'member.jpg' && member_list.avatar != null"
                            :src="'https://guide.msoftit.com/' + member_list.avatar" alt="avatar" class="image">
                        <img v-if="!member_list.avatar || member_list.avatar == 'member.jpg'"
                            :src="'assets/img/sample/avatar/avatar1.png'" alt="avatar" class="image">
                        <span class="button-payment payment-verified" v-if="member_list.payment_status == 'Paid'">
                            <ion-icon name="card-outline"></ion-icon>
                        </span>
                        <span class="button abroad" v-if="member_list.abroad">
                            <ion-icon name="airplane-outline"></ion-icon>
                        </span>
                        <span class="button verified" v-if="member_list.verified == 'Y'">
                            <ion-icon name="checkmark-outline"></ion-icon>
                        </span>
                        <span class="button not-verified" v-if="member_list.verified == 'N'">
                            <ion-icon name="close-outline"></ion-icon>
                        </span>
                        <!-- QHLS avatar flag removed as requested -->
                    </a>
                </div>
                <div class="in">
                    <div class="min-width-50">
                        <!-- <header>User</header> -->
                        <b> {{ member_list.name }} </b>
                        <footer>{{ member_list.country_code }} {{ member_list.mobile }}<span class="qhls-text"
                                v-if="((permissions.qhls ? permissions.qhls.view : false) && (member_list.qhls_reg == 1 || member_list.qhls_registered))">,{{
                                    unit.qhls_register_text }}</span>
                            <span v-if="member_list.kyc_status"><br>
                                {{ member_list.kyc_status_label }} : <b class="mal-text"
                                    v-bind:class="member_list.kyc_status_class">{{ member_list.kyc_status }}</b></span>
                            <span v-if="member_list.kyc_status"><br>
                                {{ member_list.kyc_status_label }} : <b class="mal-text"
                                    v-bind:class="member_list.kyc_status_class">{{ member_list.kyc_status }}</b></span>
                            <span v-if="member_list.kyc_status_2"><br>
                                {{ member_list.kyc_status_label_2 }} : <b class="mal-text"
                                    v-bind:class="member_list.kyc_status_class_2">{{ member_list.kyc_status_2 }}</b></span>
                            <span v-if="member_list.kyc_status_3"><br>
                                {{ member_list.kyc_status_label_3 }} : <b class="mal-text"
                                    v-bind:class="member_list.kyc_status_class_3">{{ member_list.kyc_status_3 }}</b></span>
                            <span v-if="member_list.kyc_status_4 && member_list.kyc_status_label_4 == 'Nerpatham'"><br>
                                {{ member_list.kyc_status_label_4 }} : <b class="mal-text"
                                    v-bind:class="member_list.kyc_status_class_4">{{ member_list.kyc_status_4 }}</b></span>
                            <span v-if="member_list.qhls_status"><br>
                                QHLS : <b class="mal-text" :class="member_list.qhls_status_class">{{ member_list.qhls_status }}</b></span>
                            <div class="form-check form-check-inline" v-if="currentUser.testing_user == 'Y5388'">
                                <input class="form-check-input" type="checkbox" :checked="member_list.verified == 'Y'"
                                    :id="'inlineCheckbox' + member_list.id" value="1"
                                    v-model="verification_check[member_list.id]"
                                    @click="verificationCheckClick(1, member_list.id)">
                                <label class="form-check-label green-tick" :for="'inlineCheckbox' + member_list.id">
                                    <ion-icon name="checkmark-outline"></ion-icon>
                                </label>
                            </div>
                            <div class="form-check form-check-inline" v-if="currentUser.testing_user == 'Y5388'">
                                <input class="form-check-input" type="checkbox"
                                    :checked="member_list.verified == 'N' && member_list.verification_status"
                                    :id="'inlineCheckbox_' + member_list.id" value="0"
                                    v-model="not_verification_check[member_list.id]"
                                    @click="verificationCheckClick(0, member_list.id)">
                                <label class="form-check-label red-cross" :for="'inlineCheckbox_' + member_list.id">
                                    <ion-icon name="close-outline"></ion-icon>
                                </label>
                            </div>
                        </footer>
                    </div>
                    <div class="progress float-right" v-if="member_list.fillStatus > 0 && member_list.verified != 'Y'"
                        :set="background_ = member_list.fillStatus >= 100 ? '#059205' : '#1a418c'">
                        <div class="progress-bar" role="progressbar"
                            :style="{ width: member_list.fillStatus + '%', background: background_ }" aria-valuenow="85"
                            aria-valuemin="0" aria-valuemax="100">{{ member_list.fillStatus }}%</div>
                    </div>
                    <div class="card-button dropdown">
                        <button type="button" class="btn btn-link btn-icon" data-bs-toggle="modal"
                            :data-bs-target="'#actionSheetInset' + member_list.id" @click="showActionModel">
                            <ion-icon name="ellipsis-vertical-outline"></ion-icon>
                        </button>
                    </div>

                    <!-- Default Action Sheet Inset -->

                    <!-- Default Action Sheet Inset -->
                    <div class="modal fade action-sheet" :id="'actionSheetInset' + member_list.id" tabindex="-1"
                        role="dialog">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">Action</h5>
                                </div>
                                <div class="modal-body">
                                    <ul class="action-button-list">
                                        <!-- <li v-if="this.permissions.nerpatham.create">
                                            <a href="javascript:void(0)" class="btn btn-list" data-bs-dismiss="modal"
                                                @click="nerpathamView(member_list)">
                                                <span>
                                                    <ion-icon name="book-outline"></ion-icon>നേർപഥം ചേർക്കാൻ
                                                </span>
                                            </a>
                                        </li> -->
                                        <li v-if="member_list.membership_form_url">
                                            <a :href="member_list.membership_form_url" target="_blank" class="btn btn-list text-danger">
                                                <span>
                                                    <ion-icon name="document-outline"></ion-icon> Download Form
                                                </span>
                                            </a>
                                        </li>
                                        <li v-if="this.permissions.members.convert_member">
                                            <a href="javascript:void(0)" class="btn btn-list" data-bs-dismiss="modal"
                                                @click="formCollected(member_list)">
                                                <span>
                                                    <ion-icon name="checkmark-done-outline"></ion-icon>{{ $t('form_collected_status') }}
                                                </span>
                                            </a>
                                        </li>
                                        <li v-if="member_list.not_renewed && this.permissions.members.convert_member">
                                            <a href="javascript:void(0)" class="btn btn-list" data-bs-dismiss="modal"
                                                @click="openRenewDialog(member_list)">
                                                <span>
                                                    <ion-icon name="refresh-outline"></ion-icon> {{ $t('renew_membership') }}
                                                </span>
                                            </a>
                                        </li>
                                        <li v-if="!member_list.not_renewed && this.permissions.members.convert_member">
                                            <a :href="'https://wa.me/' + (member_list.whatsapp_country_code + member_list.whatsapp) +'?text=വിസ്ഡം മെമ്പർഷിപ്പിലേക്ക് സ്വാഗതം%0A%0Aവീഡിയോ കാണുക: https://youtu.be/Hqn56eiB1lA%0A%0Aവിസ്ഡം ഗൈഡ് ലിങ്ക് : guide.wisdomislam.org'" class="btn btn-list"
                                                >
                                                <span>
                                                    <ion-icon name="refresh-outline"></ion-icon>{{ $t('send_guide_link') }}
                                                </span>
                                            </a>
                                        </li>
                                        <!-- <li v-if="this.permissions.members.member_current_status && !member_list.transfered_status">
                                            <a :href="'https://guideportal.wisdomislam.org/members-followup/' + member_list.id"
                                                class="btn btn-list">
                                                <span>
                                                    <ion-icon name="pencil-outline"></ion-icon>ഇപ്പോഴത്തെ സ്റ്റാറ്റസ്
                                                </span>
                                            </a>
                                        </li> -->
                                        <li v-if="this.permissions.members.member_current_status">
                                            <a href="javascript:void(0)" class="btn btn-list" data-bs-dismiss="modal"
                                                @click="abroadView(member_list)">
                                                <span>
                                                    <ion-icon name="book-outline"></ion-icon>{{ $t('member_current_status') }}
                                                </span>
                                            </a>
                                        </li>
                                        <li v-if="this.permissions.qhls.create">
                                            <a href="javascript:void(0)" class="btn btn-list" data-bs-dismiss="modal"
                                                @click="qhlsView(member_list)">
                                                <span>
                                                    <ion-icon name="easel-outline"></ion-icon>{{ $t('qhls_register') }}
                                                </span>
                                            </a>
                                        </li>
                                        <!-- <li v-if="this.permissions.verification.create">
                                            <a href="javascript:void(0)" class="btn btn-list" data-bs-dismiss="modal"
                                                @click="verificationProcess(member_list)">
                                                <span>
                                                    <ion-icon name="checkmark-done-outline"></ion-icon>Verification
                                                </span>
                                            </a>
                                        </li> -->
                                        <li v-if="this.permissions.members.convert_member">
                                            <a href="javascript:void(0)" class="btn btn-list" data-bs-dismiss="modal"
                                                @click="openChangeUnitModal(member_list)">
                                                <span>
                                                    <ion-icon name="swap-horizontal-outline"></ion-icon> {{  $t('change_unit') }}
                                                </span>
                                            </a>
                                        </li>
                                        <li v-if="this.permissions.lajna_membership_add">
                                            <a href="javascript:void(0)" class="btn btn-list" data-bs-dismiss="modal"
                                                @click="lajnaMemberProcess(member_list)">
                                                <span>
                                                    <ion-icon name="checkmark-done-outline"></ion-icon>{{ $t('lajna_membership') }}
                                                </span>
                                            </a>
                                        </li>

                                        <li
                                            v-if="this.permissions.verification.view && (member_list.verified == 'Y' || (member_list.verified == 'N' && member_list.verification_history))">
                                            <a href="javascript:void(0)" class="btn btn-list" data-bs-dismiss="modal"
                                                @click="verificationReport(member_list)">
                                                <span>
                                                    <ion-icon name="checkbox-outline"></ion-icon>{{ $t('verification_report') }}
                                                </span>
                                            </a>
                                        </li>
                                        <li
                                            v-if="this.permissions.members.biodata && member_list.user_id && currentUser.unit_id == member_list.unit_id && member_list.fillStatus >= 100">
                                            <a href="javascript:void(0)" class="btn btn-list" data-bs-dismiss="modal"
                                                @click="downloadBiodata(member_list)">
                                                <span>
                                                    <ion-icon name="print-outline"></ion-icon> {{ $t('download_biodata') }}
                                                </span>
                                            </a>
                                        </li>
                                        <li
                                            v-if="this.permissions.members.biodata && member_list.user_id && ((currentUser.user_level <= 4 && currentUser.unit_id == member_list.unit_id) || (currentUser.user_level <= 3 && currentUser.zone_id == member_list.zone_id) || (currentUser.user_level <= 2 && currentUser.district_id == member_list.district_id) || currentUser.user_level == 1)">
                                            <a href="javascript:void(0)" class="btn btn-list" data-bs-dismiss="modal"
                                                @click="goToBiodata(member_list)">
                                                <span>
                                                    <ion-icon name="receipt-outline"></ion-icon>{{ $t('view_biodata') }}
                                                </span>
                                            </a>
                                        </li>
                                        <li v-if="this.permissions.members.call">
                                            <a :href="'tel:' + member_list.mobile" class="btn btn-list">
                                                <span>
                                                    <ion-icon name="call-outline"></ion-icon> {{ $t('call') }}
                                                </span>
                                            </a>
                                        </li>
                                        <li v-if="member_list.whatsapp && this.permissions.members.whatsapp">
                                            <a :href="'https://wa.me/' + member_list.whatsapp_country_code + member_list.whatsapp + '?text='"
                                                class="btn btn-list">
                                                <span>
                                                    <ion-icon name="logo-whatsapp"></ion-icon> {{ $t('whatsapp') }}
                                                </span>
                                            </a>
                                        </li>
                                        <li v-if="this.permissions.members.edit">
                                            <a href="javascript:void(0)" @click="memberView(member_list)"
                                                class="btn btn-list" data-bs-dismiss="modal">
                                                <span>
                                                    <ion-icon name="pencil-outline"></ion-icon> {{ $t('edit') }}
                                                </span>
                                            </a>
                                        </li>
                                        <li v-if="this.permissions.members.delete">
                                            <a href="javascript:void(0)" @click="adminDelete(member_list, 'unit')"
                                                class="btn btn-list" data-bs-dismiss="modal">
                                                <span>
                                                    <ion-icon name="trash-outline"></ion-icon> {{ $t('delete') }}
                                                </span>
                                            </a>
                                        </li>
                                        <li v-if="member_list.fillStatus < 100 && permissions.members.convert_to_pending_member">
                                            <a href="javascript:void(0)" class="btn btn-list" data-bs-dismiss="modal"
                                                @click="openSendToPendingDialog(member_list)">
                                                <span>
                                                    <ion-icon name="refresh-outline"></ion-icon> {{ $t('send_to_pending_members_list') }}
                                                </span>
                                            </a>
                                        </li>
                                        <li class="action-divider"></li>
                                        <li>
                                            <a href="#" class="btn btn-list text-danger" data-bs-dismiss="modal">
                                                <span>
                                                    <ion-icon name="close-outline"></ion-icon> {{ $t('cancel') }}
                                                </span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- * Default Action Sheet Inset -->
                </div>
            </a>
        </li>
    </ul>
    <div class="listview-title mt-0 mal-text text-primary" v-if="!loading_list && trash_list.length">{{ $t('delete_members_list') }}</div>
    <ul class="listview image-listview inset text mt-0 deleted-list" v-if="!loading_list && trash_list.length">
        <li v-for="(trash_member_list, index) in trash_list" v-bind:key="trash_member_list.id"
            :set="background = trash_member_list.fillStatus <= 0 ? 'rgb(242 187 202)' : trash_member_list.fillStatus >= 90 ? 'rgb(209 232 210)' : '#ffffff'"
            :style="{ 'background-color': background }">
            <a href="javascript:void(0)" class="item">
                <span class="sl-no">{{ index + 1 }}</span>
                <img src="assets/img/sample/avatar/avatar1.png" alt="image" class="image">
                <div class="in">
                    <div class="min-width-50">
                        <b> {{ trash_member_list.name }} </b>
                        <footer>{{ trash_member_list.country_code }} {{ trash_member_list.mobile }} <br>
                            <span v-if="trash_member_list.delete_requested_status"
                                v-html="trash_member_list.delete_requested_status"></span>
                        </footer>
                    </div>
                    <div class="progress float-right" v-if="trash_member_list.fillStatus > 0"
                        :set="background_ = trash_member_list.fillStatus >= 100 ? '#059205' : '#1a418c'">
                        <div class="progress-bar" role="progressbar"
                            :style="{ width: trash_member_list.fillStatus + '%', background: background_ }"
                            aria-valuenow="85" aria-valuemin="0" aria-valuemax="100">{{ trash_member_list.fillStatus }}%
                        </div>
                    </div>
                    <div class="card-button dropdown">
                        <button type="button" class="btn btn-link btn-icon" data-bs-toggle="modal"
                            :data-bs-target="'#actionSheetInset' + trash_member_list.id" @click="showActionModel">
                            <ion-icon name="ellipsis-horizontal"></ion-icon>
                        </button>
                    </div>

                    <div class="modal fade action-sheet" :id="'actionSheetInset' + trash_member_list.id" tabindex="-1"
                        role="dialog">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">{{ $t('action') }}</h5>
                                </div>
                                <div class="modal-body">
                                    <ul class="action-button-list">
                                        <li v-if="this.permissions.members.delete_approval">
                                            <a href="javascript:void(0)"
                                                @click="adminDelete(trash_member_list, 'zone', 'approved')"
                                                class="btn btn-list text-danger" data-bs-dismiss="modal">
                                                <span>
                                                    <ion-icon name="trash-outline"></ion-icon>{{ $t('approve_delete_request') }}
                                                </span>
                                            </a>
                                        </li>
                                        <li v-if="this.permissions.members.delete_approval">
                                            <a href="javascript:void(0)"
                                                @click="adminDelete(trash_member_list, 'zone', 'rejected')"
                                                class="btn btn-list text-primary" data-bs-dismiss="modal">
                                                <span>
                                                    <ion-icon name="trash-outline"></ion-icon>{{ $t('reject_delete_request') }}
                                                </span>
                                            </a>
                                        </li>
                                        <li v-if="this.permissions.members.delete_undo">
                                            <a href="javascript:void(0)"
                                                @click="adminDelete(trash_member_list, 'unit', 'undo')"
                                                class="btn btn-list text-success" data-bs-dismiss="modal">
                                                <span>
                                                    <ion-icon name="trash-outline"></ion-icon> {{ $t('cancel_delete_request') }}
                                                </span>
                                            </a>
                                        </li>
                                        <li>
                                            <a :href="'tel:' + trash_member_list.mobile" class="btn btn-list">
                                                <span>
                                                    <ion-icon name="call-outline"></ion-icon> {{ $t('call') }}
                                                </span>
                                            </a>
                                        </li>
                                        <li v-if="trash_member_list.whatsapp">
                                            <a :href="'https://wa.me/' + trash_member_list.whatsapp_country_code + trash_member_list.whatsapp + '?text='"
                                                class="btn btn-list">
                                                <span>
                                                    <ion-icon name="logo-whatsapp"></ion-icon> {{ $t('whatsapp') }}
                                                </span>
                                            </a>
                                        </li>

                                        <li class="action-divider"></li>
                                        <li>
                                            <a href="#" class="btn btn-list text-danger" data-bs-dismiss="modal">
                                                <span>
                                                    <ion-icon name="close-outline"></ion-icon> {{ $t('cancel') }}
                                                </span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </a>
        </li>
    </ul>
    <alert-model :type="alert_type" :message="alert_message" ref="alert_model"></alert-model>
    <dialog-model :message="dialog_message" :action_method="dialog_action" :action_method_params="dialog_action_params"
        ref="dialog_model"></dialog-model>
    <!-- Change Unit Modal -->
    <div class="modal fade action-sheet" id="changeUnitModal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $t('change_unit') }}</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <form @submit.prevent="submitChangeUnit">
                            <div class="form-group basic">
                                <label class="label" for="districtSelect">{{ $t('select_district') }}</label>
                                <select v-model="selectedDistrict" class="form-control" id="districtSelect"
                                    @change="onDistrictChange" required>
                                    <option value="">-- {{ $t('select_district') }} --</option>
                                    <option v-for="district in district_list" :key="district.id" :value="district.id">{{
                                        district.name }}</option>
                                </select>
                            </div>
                            <div class="form-group basic">
                                <label class="label" for="zoneSelect">{{ $t('select_zone') }}</label>
                                <select v-model="selectedZone" class="form-control" id="zoneSelect"
                                    @change="onZoneChange" required>
                                    <option value="">-- {{ $t('select_zone') }} --</option>
                                    <option v-for="zone in zone_list" :key="zone.id" :value="zone.id">{{ zone.name }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group basic">
                                <label class="label" for="unitSelect">{{ $t('select_unit') }}</label>
                                <select v-model="selectedUnit" class="form-control" id="unitSelect" required>
                                    <option value="">-- {{ $t('select_unit') }} --</option>
                                    <option v-for="unit in unit_list" :key="unit.id" :value="unit.id">{{ unit.name }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group basic">
                                <label class="label" for="changeReason">{{ $t('reason') }}</label>
                                <textarea v-model="changeUnitForm.reason" class="form-control" id="changeReason"
                                    rows="3" required></textarea>
                            </div>
                            <div class="form-group basic mb-0 text-right d-flex justify-content-end gap-2">
                                <button type="submit" class="btn btn-primary btn-block btn-lg" :disabled="loading">
                                    <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                                    {{ $t('submit') }}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Form, Field, ErrorMessage } from "vee-validate";
import * as yup from "yup";
import UserService from "../services/user.service";
import $ from 'jquery';

import AlertModel from "./layouts/AlertModel.vue";
import DialogModel from "./layouts/DialogModel.vue";
export default {
    name: 'Admin List',
    props: {
        unit_id: null
    },
    components: {
        Form,
        Field,
        ErrorMessage,
        AlertModel,
        DialogModel
    },
    data() {
        const nameRegex = /^[a-zA-Z0-9&._-\s]*$/g;
        const schema = yup.object().shape({
            name: yup.string().matches(nameRegex, this.$t('name_regex')).required(this.$t('name_required')),
            mobile_number: yup.string().min(10, this.$t('mobile_number_length')).required(this.$t('mobile_number_required')),
            wing: yup.string().required(this.$t('wing_required_field')),
        });
        return {
            loading: false,
            loading_list: false,
            message: "",
            country_code: '91',
            country_code_whatsapp: '91',
            mobile_number: '',
            whatsapp_number: '',
            wing: '',
            cluster: '',
            schema,
            stay: '',
            user_level: "",
            sub_levels: [],
            member_lists: [],
            member_pending_lists: [],
            temp_member_lists: [],
            orgnal_member_lists: [],
            trash_list: [],
            unit: [],
            editable_id: '',
            editable: true,
            add_admin: false,
            abroad_fields: false,
            pin_number: '',
            deletable_id: '',
            reason_to_delete: '',
            message_delete: '',
            delete_others: false,
            delete_other_text: '',
            member_id: '',
            search_qty: '',
            verification_status_list: [],
            verification_status: '',
            not_verification_status: '',
            not_verification_status_: '',
            verification_remark: '',
            verification_member_id: '',
            verification_message: '',
            verification_report: false,
            isSubscriber: '',
            receipt_no: '',
            subscription_no: '',
            nerpatham: [],
            alert_type: '',
            alert_message: '',
            dialog_message: '',
            dialog_action: '',
            dialog_action_params: [],
            verification_check: [],
            not_verification_check: [],
            country_list: [],
            isAbroad: '',
            abroadPlace: '',
            abroadCountry: '',
            lajna_member: '',
            mobile_editable : true,
            lajna_member_id: '',
            permissions: {
                view_event_registrations: '',
                qhls: [],
                nerpatham: [],
                executives: [],
                members: [],
                verification: []
            },
            changeUnitForm: {
                member_id: '',
                reason: ''
            },
            district_list: [],
            zone_list: [],
            unit_list: [],
            selectedDistrict: '',
            selectedZone: '',
            selectedUnit: '',
            unit_id_: '',
            change_unit_members: [],
            delete_from: '',
            delete_type: '',
            form_collected_member_id :'',
            form_collected : ''
        };
    },

    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },

    },
    mounted() {
        console.log(this.permissions.verification);
        if (!this.currentUser) {
            location.replace('/');
        } else {
            this.user_level = parseInt(this.$route.params.sub_level);
            this.unit_id_ = parseInt(this.$route.params.id);
            this.getMembersList(1);
            if ((this.unit_id_ == this.currentUser.unit_id) && this.currentUser.user_level <= 4) {
                this.editable = true;
            } else {
                this.editable = false;
            }
            this.$root.updateParent(this.$t('members_list'));
        }
        this.getComboboxValues('COUNTRY');
        this.getComboboxValues('COUNTRY_CODE');
        window.onpopstate = function () {
            if ($('body').hasClass('modal-open')) {
                location.reload();
            }
        };
    },
    methods: {
        getComboboxValues(code, id = null) {
            var data = {
                code: code,
                type_id: id
            }
            UserService.getCombobox(data).then(
                (response) => {
                    switch (code) {
                        case 'COUNTRY_CODE':
                            this.country_code_list = response.data.data.list.options;
                            break;
                        case 'COUNTRY':
                            this.country_list = response.data.data.list.options;
                            break;

                        case 'UNVERIFIED_REASON':
                            this.verification_status_list = response.data.data.list.options;
                            break;

                        default:
                            break;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.messafe = (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        getMembersList(wing) {
            this.loading_list = true;
            let data = {
                unit_id: this.unit_id_ ? this.unit_id_ : this.currentUser.unit_id,
                wing: wing,
                members_list: false,
                temp_members_list: false
            }
            UserService.authPostRequest('get-members', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.member_lists = response.data.data.list;
                        this.member_pending_lists = response.data.data.pending_list;
                        this.search_qty = '';
                        this.orgnal_member_lists = response.data.data.list;
                        this.trash_list = response.data.data.trash_list;
                        this.temp_member_lists = response.data.data.temp_list;
                        this.unit = response.data.data.unit;
                        this.wing = wing;
                        this.permissions = response.data.data.permissions;
                        this.loading_list = false;
                        this.change_unit_members = response.data.data.change_unit_members || [];
                    } else {
                        this.loading_list = true;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        memberView(admin) {
            $('#addMemberModel').modal('show');
            this.wing = admin.wing;
            this.mobile_number = admin.mobile;
            this.name = admin.name;
            this.country_code = admin.country_code;
            this.editable_id = admin.id;
            this.whatsapp_number = admin.whatsapp;
            if(admin.edited_time){
                this.mobile_editable = false;
            }else{
                this.mobile_editable = true;
            }
            this.country_code_whatsapp = admin.whatsapp_country_code != '' ? admin.whatsapp_country_code : '91';
            if (admin.country_code != '91') {
                this.abroad_fields = true;
            } else {
                this.abroad_fields = false;
            }

            this.add_admin = true;
        },
        adminDeleteChange(event) {
            if (event.target.value == 'Other') {
                this.delete_others = true;
            } else {
                this.delete_others = false;
            }
        },
        adminDelete(member, from = 'unit', type = null) {
            this.deletable_id = member.id;
            this.delete_from = from;
            this.delete_type = type;
            $('#deleteMemberModel').modal('show');
        },
        memberDelete() {
            if (this.reason_to_delete || this.delete_type) {
                this.message_delete = '';
                var data = {
                    id: this.deletable_id,
                    reason: !this.delete_others ? this.reason_to_delete : this.delete_other_text,
                    delete_from: this.delete_from,
                    delete_type: this.delete_type
                }
                // this.$swal.fire({
                //     title: '',
                //     text: "ഉറപ്പായും ഡിലീറ്റ് ചെയ്യണോ ?",
                //     icon: 'warning',
                //     showCancelButton: true,
                //     confirmButtonColor: '#3085d6',
                //     cancelButtonColor: '#d33',
                //     confirmButtonText: 'Yes, delete it!'
                // }).then((result) => {
                //     if (result.isConfirmed) {
                UserService.authPostRequest('delete-members', data).then(
                    (response) => {
                        if (response.data.status == 'success') {
                            this.deletable_id = ''
                            this.reason_to_delete = ''
                            this.delete_others = false
                            this.delete_other_text = ''
                            $('#deleteMemberModel').modal('hide');
                            this.$swal.fire(
                                '',
                                response.data.message,
                                'success'
                            );
                            this.getMembersList(this.wing);
                            this.loading = false;
                        } else if (response.data.status == 'warning') {
                            $('#deleteMemberModel').modal('hide');
                            this.$swal.fire(
                                '',
                                response.data.message,
                                'warning'
                            );
                            this.getMembersList(this.wing);
                            this.loading = false;
                        } else {
                            this.loading = true;
                        }
                    },
                    (error) => {
                        this.loading = false;
                        this.message =
                            (error.response &&
                                error.response.data &&
                                error.response.data.message) ||
                            error.message ||
                            error.toString();
                    }
                );
                //     }
                // })
            } else {
                this.message_delete = 'ഡിലീറ്റ് ചെയ്യാനുള്ള കാരണം സെലക്ട് ചെയ്യുക';
            }

        },
        downloadBiodata(member_list) {
            let data = {
                id: member_list.id
            }
            UserService.authPostRequest('download-member-pdf', data).then(
                (response) => {
                    if (response) {
                        // let blob = new Blob([response], {
                        //     type: 'application/pdf'
                        // })
                        // let link = document.createElement('a')
                        // link.href = response.data.data.link
                        // link.setAttribute('download', 'file.pdf');
                        // link.click()

                        // window.open(response.data.data.link)

                        const link = document.createElement('a');
                        link.href = response.data.data.link
                        link.setAttribute('download', member_list.name + ' biodata-form.pdf'); //or any other extension
                        document.body.appendChild(link);
                        link.click();

                        this.loading = false;
                    } else {
                        this.loading = true;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        goToBiodata(member_list) {
            this.$router.push('/bio-data/' + member_list.user_id);
        },
        showActionModel() {
            this.pin_number = '';
        },
        getPin(member) {
            this.loading = true;
            this.pin_number = '';
            var user = {
                id: member.id
            }
            UserService.authPostRequest('get-pin', user).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.pin_number = response.data.data.pin;
                        this.loading = false;
                    } else if (response.data.status == 'error') {
                        this.loading = false;
                    } else {
                        this.loading = false;
                    }
                },
                (error) => {
                    if (error)
                        this.loading = false;
                }
            );
        },
        adminAdd() {
            $('#addMemberModel').modal('show');
            this.wing = '';
            this.mobile_number = '';
            this.name = '';
            this.country_code = '91';
            this.editable_id = null;
            this.add_admin = true;
        },
        addMember(user) {
            user.id = this.editable_id;
            user.unit_id = this.unit_id_ ? this.unit_id_ : this.currentUser.unit_id;
            user.added_by = this.currentUser.id;
            user.type = 'temp_member';
            this.loading = true;
            UserService.authPostRequest('members', user).then(
                (response) => {
                    if (response.data.status == 'success') {
                        $('#addMemberModel').modal('hide')
                        this.$swal('', response.data.message, 'seccess');
                        this.getMembersList(user.wing);
                        this.loading = false;
                    } else if (response.data.status == 'error') {
                        this.message = response.data.message;
                        this.loading = false;
                    } else {
                        this.loading = false;
                    }
                },
                (error) => {
                    this.loading = false;

                    this.messafe = (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );

        },
        closeAddMemberModel() {
            $('#addMemberModel').modal('hide');
        },
        closeVerificationModel() {
            $('#verificationModel').modal('hide');
        },
        closeLajnaModel() {
            $('#lajnaMemberModel').modal('hide');
        },
        onChangeCountryCode(event) {
            if (event.target.value != '91') {
                this.abroad_fields = true;
            } else {
                this.abroad_fields = false;
            }
            console.log(event.target.value);
        },
        verificationProcess(member) {
            this.verification_message = '';
            this.verification_report = false;
            this.getComboboxValues('UNVERIFIED_REASON');
            this.verification_member_id = member.id;
            this.verification_status = member.verified;
            this.verification_remark = member.verification_comments;
            this.not_verification_status = member.verification_status;
            $('#verificationModel').modal('show');
        },
        verificationReport(member) {
            this.verification_message = '';
            this.verification_report = true;
            this.getComboboxValues('UNVERIFIED_REASON');
            this.verification_member_id = member.id;
            this.verification_status = member.verified;
            this.verification_remark = member.verification_comments;
            this.not_verification_status = member.verification_status;
            this.not_verification_status_ = member.reject_reason.item_value_display;

            $('#verificationModel').modal('show');
        },
        memberVerify() {
            this.verification_message = '';
            if (!this.verification_status) {
                this.verification_message = 'സ്റ്റാറ്റസ് സെലക്ട് ചെയ്യുക';
                return 0;
            }
            if (this.verification_status == "N" && !this.not_verification_status) {
                this.verification_message = 'കാരണം സെലക്ട് ചെയ്യുക';
                return 0;
            }
            var data = {
                id: this.verification_member_id,
                verification_status: this.verification_status,
                not_verification_status: this.not_verification_status,
                verification_remark: this.verification_remark,
                type: 'temp_to_member'
            }
            UserService.authPostRequest('member-verification', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.verification_member_id = ''
                        this.verification_status = ''
                        this.verification_remark = ''
                        this.not_verification_status = ''
                        $('#verificationModel').modal('hide');
                        this.$swal.fire(
                            '',
                            response.data.message,
                            'success'
                        );
                        this.getMembersList(this.wing);
                        this.loading = false;
                    } else if (response.data.status == 'warning') {
                        this.$swal.fire(
                            '',
                            response.data.message,
                            'warning'
                        );
                        this.loading = false;
                    } else {
                        this.loading = true;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        lajnaMemberProcess(member) {
            this.lajna_member_id = member.id;
            this.lajna_member = member.lajna_member;
            $('#lajnaMemberModel').modal('show');
        },
        memberLajnaMamberSave() {
            var data = {
                member_id: this.lajna_member_id,
                lajna_member: this.lajna_member,
            }
            UserService.authPostRequest('lajna-membership', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        $('#lajnaMemberModel').modal('hide');
                        this.$swal.fire(
                            '',
                            response.data.message,
                            'success'
                        );
                        this.getMembersList(this.wing);
                        this.loading = false;
                    } else if (response.data.status == 'warning') {
                        this.$swal.fire(
                            '',
                            response.data.message,
                            'warning'
                        );
                        this.loading = false;
                    } else {
                        this.loading = true;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },

        formCollected(member) {
        this.form_collected_member_id = member.id;
        this.form_collected = member?member.form_collected:'N';
        $('#formCollectedModel').modal('show');
        },
        formCollectedSave() {
            var data = {
                member_id: this.form_collected_member_id,
                form_collected: this.form_collected,
            }
            UserService.authPostRequest('form-collected', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        $('#formCollectedModel').modal('hide');
                        this.$swal.fire(
                            '',
                            response.data.message,
                            'success'
                        );
                        this.getMembersList(this.wing);
                        this.loading = false;
                    } else if (response.data.status == 'warning') {
                        this.$swal.fire(
                            '',
                            response.data.message,
                            'warning'
                        );
                        this.loading = false;
                    } else {
                        this.loading = true;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },

        filteredMembers() {
            this.loading_list = true;
            let filter_list = this.orgnal_member_lists;

            filter_list = filter_list.filter((samsung) => {
                return this.search_qty.toLowerCase().split(' ').every(v => samsung.name.toLowerCase().includes(v)) || this.search_qty.toLowerCase().split(' ').every(v => samsung.mobile.toLowerCase().includes(v));
            });
            // filter_list = filter_list.filter((item) => {
            //     if (item.toLowerCase().indexOf(this.search_qty) > -1) {
            //         return item;
            //     }
            // })
            this.member_lists = filter_list;
            this.loading_list = false;
        },
        abroadView(member) {
            this.member_id = member.id;
            this.isAbroad = member.isAbroad;
            this.abroadPlace = member.abroadPlace;
            this.abroadCountry = member.abroadCountry;
            this.abroadMobile = member.abroadMobile;
            $('#addAbroadModel').modal('show');
        },
        addAbroad(user) {
            user.member_id = this.member_id;
            user.editable_id = this.editable_id;
            user.unit_id = parseInt(this.$route.params.id);
            user.isAbroad = this.isAbroad;
            user.abroadPlace = this.abroadPlace;
            user.abroadCountry = this.abroadCountry;
            UserService.addAdmin('store-abroad-status', user).then(
                (response) => {
                    if (response.data.status == 'success') {
                        $('#addAbroadModel').modal('hide')
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.getMembersList(this.wing);
                        this.loading = false;
                        this.message = '';
                    } else if (response.data.status == 'warning') {
                        this.alert_type = 'Warning';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else if (response.data.status == 'error') {
                        this.alert_type = 'Error';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else {
                        this.loading = false;
                    }
                },
                (error) => {
                    this.loading = false;

                    this.messafe = (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        nerpathamView(member) {
            this.member_id = member.id;
            if (member.nerpatham) {
                this.nerpatham = member.nerpatham;
                this.editable_id = this.nerpatham.id;
                this.subscription_no = this.nerpatham.subscription_no;
                this.receipt_no = this.nerpatham.reciept_no;
            } else {
                this.nerpatham = [];
                this.editable_id = null;
                this.subscription_no = null;
                this.receipt_no = null;
            }


            $('#addNerpathamModel').modal('show');
        },
        addNerpatham(user) {
            user.member_id = this.member_id;
            user.editable_id = this.editable_id;
            user.unit_id = parseInt(this.$route.params.id);
            user.isSubscriber = this.isSubscriber;
            UserService.addAdmin('store-nerpatham-subscriptions', user).then(
                (response) => {
                    if (response.data.status == 'success') {
                        $('#addNerpathamModel').modal('hide')
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.getMembersList(1, 6);
                        this.loading = false;
                        this.message = '';
                    } else if (response.data.status == 'warning') {
                        this.alert_type = 'Warning';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else if (response.data.status == 'error') {
                        this.alert_type = 'Error';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else {
                        this.loading = false;
                    }
                },
                (error) => {
                    this.loading = false;

                    this.messafe = (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        verificationCheckClick(type, id) {
            console.log(type, id, this.verification_check[id], this.not_verification_check[id]);
            if (type == 1) {
                if (this.verification_check[id] == true) {
                    this.verification_check[id] = false;
                } else if (this.verification_check[id] === undefined || this.verification_check[id] == false) {
                    this.verification_check[id] = true;
                    this.not_verification_check[id] = false;
                }
            } else {
                if (this.not_verification_check[id] == true) {
                    this.not_verification_check[id] = false;
                } else if (this.not_verification_check[id] === undefined || this.not_verification_check[id] == false) {
                    this.not_verification_check[id] = true;
                    this.verification_check[id] = false;
                }
            }
            var data = [];
            if (this.verification_check[id] == true) {
                data = {
                    id: id,
                    verification_status: 'Y',
                    not_verification_status: '',
                    verification_remark: '',
                }
            } else {
                data = {
                    id: id,
                    verification_status: 'N',
                    not_verification_status: '1002',
                    verification_remark: '',
                }
            }
            if (this.verification_check[id] == true || this.not_verification_check[id] == true) {
                UserService.authPostRequest('member-verification', data).then(
                    (response) => {
                        if (response.data.status == 'success') {
                            // this.getMembersList(this.wing);
                        }
                    },
                    (error) => {
                        this.loading = false;
                        this.message =
                            (error.response &&
                                error.response.data &&
                                error.response.data.message) ||
                            error.message ||
                            error.toString();
                    }
                );
            }

        },
        qhlsView(member) {
            this.member_id = member.id;
            var data = {
                id: member.id,
                wing: member.wing
            }
            this.dialog_action_params = data;
            if (member.qhls_reg == 1) {
                this.dialog_message = 'ഈ മെമ്പറെ രജിസ്റ്റർ ചെയ്തിട്ടുണ്ട്. രെജിസ്ട്രേഷൻ ക്യാൻസൽ ചെയ്യണോ?';
            } else {
                this.dialog_message = 'ഈ മെമ്പറെ രജിസ്റ്റർ ചെയ്യണോ?';
            }
            this.dialog_action = 'qhlsReg';
            this.$refs.dialog_model.openModel();
            this.loading = false;
        },
        qhlsReg(data) {
            UserService.addAdmin('qhls-registration', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.getMembersList(data.wing);
                        this.loading = false;
                        this.message = '';
                    } else if (response.data.status == 'warning') {
                        this.alert_type = 'Warning';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else if (response.data.status == 'error') {
                        this.alert_type = 'Error';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else {
                        this.loading = false;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.messafe = (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        openRenewDialog(member) {
            this.dialog_message = 'Do you want to renew this member?';
            this.dialog_action = 'renewMember';
            this.dialog_action_params = [member];
            this.$refs.dialog_model.openModel();
        },
        async renewMember([member]) {
            const data = {
                id: member.id,
                verification_status: 'Y',
                type: 'renew_member'
            };
            this.loading = true;
            try {
                const response = await UserService.authPostRequest('member-verification', data);
                if (response.data.status === 'success') {
                    this.alert_type = 'Success';
                    this.alert_message = response.data.message;
                    this.$refs.alert_model.openModel();
                    this.getMembersList(this.wing);
                } else {
                    this.alert_type = 'Error';
                    this.alert_message = response.data.message;
                    this.$refs.alert_model.openModel();
                }
            } catch (error) {
                this.alert_type = 'Error';
                this.alert_message = error.message || 'An error occurred';
                this.$refs.alert_model.openModel();
            }
            this.loading = false;
        },

        openRestoreDialog(member) {
            this.dialog_message = 'Do you want to restore this member?';
            this.dialog_action = 'restoreMember';
            this.dialog_action_params = [member];
            this.$refs.dialog_model.openModel();
        },
        async restoreMember([member]) {
            const data = {
                id: member.id,
                verification_status: 'Y',
                type: 'restoreMember'
            };
            this.loading = true;
            try {
                const response = await UserService.authPostRequest('member-verification', data);
                if (response.data.status === 'success') {
                    this.alert_type = 'Success';
                    this.alert_message = response.data.message;
                    this.$refs.alert_model.openModel();
                    this.getMembersList(this.wing);
                } else {
                    this.alert_type = 'Error';
                    this.alert_message = response.data.message;
                    this.$refs.alert_model.openModel();
                }
            } catch (error) {
                this.alert_type = 'Error';
                this.alert_message = error.message || 'An error occurred';
                this.$refs.alert_model.openModel();
            }
            this.loading = false;
        },


        openSendToPendingDialog(member) {
            this.dialog_message = 'Do you want to send this member to pending List?';
            this.dialog_action = 'sendToPendingMember';
            this.dialog_action_params = [member];
            this.$refs.dialog_model.openModel();
        },
        async sendToPendingMember([member]) {
            const data = {
                id: member.id,
                verification_status: 'Y',
                type: 'pending_member'
            };
            this.loading = true;
            try {
                const response = await UserService.authPostRequest('member-verification', data);
                if (response.data.status === 'success') {
                    this.alert_type = 'Success';
                    this.alert_message = response.data.message;
                    this.$refs.alert_model.openModel();
                    this.getMembersList(this.wing);
                } else {
                    this.alert_type = 'Error';
                    this.alert_message = response.data.message;
                    this.$refs.alert_model.openModel();
                }
            } catch (error) {
                this.alert_type = 'Error';
                this.alert_message = error.message || 'An error occurred';
                this.$refs.alert_model.openModel();
            }
            this.loading = false;
        },

        getDistrictList() {
            UserService.authPostRequest('get-district-by-id', {}).then(
                (response) => {
                    if (response.data.status === 'success') {
                        this.district_list = response.data.data.list;
                    } else {
                        this.district_list = [];
                    }
                },
                () => {
                    this.district_list = [];
                }
            );
        },
        getZoneList(district_id) {
            this.zone_list = [];
            this.unit_list = [];
            this.selectedZone = '';
            this.selectedUnit = '';
            if (!district_id) return;
            let data = { district_id };
            UserService.authPostRequest('get-zone-by-id', data).then(
                (response) => {
                    if (response.data.status === 'success') {
                        this.zone_list = response.data.data.list;
                    } else {
                        this.zone_list = [];
                    }
                },
                () => {
                    this.zone_list = [];
                }
            );
        },
        getUnitList(zone_id) {
            this.unit_list = [];
            this.selectedUnit = '';
            if (!zone_id) return;
            let data = { zone_id };
            UserService.authPostRequest('get-unit-by-id', data).then(
                (response) => {
                    if (response.data.status === 'success') {
                        this.unit_list = response.data.data.list;
                    } else {
                        this.unit_list = [];
                    }
                },
                () => {
                    this.unit_list = [];
                }
            );
        },
        async openChangeUnitModal(member) {
            this.changeUnitForm.member_id = member.id;
            this.changeUnitForm.reason = '';

            // Reset lists and selections
            this.district_list = [];
            this.zone_list = [];
            this.unit_list = [];
            this.selectedDistrict = '';
            this.selectedZone = '';
            this.selectedUnit = '';

            $('#changeUnitModal').modal('show'); // Show modal with loading state

            try {
                // Fetch and populate districts
                const districtResponse = await UserService.authPostRequest('get-district-by-id', {});
                if (districtResponse.data.status === 'success') {
                    this.district_list = districtResponse.data.data.list;
                    this.selectedDistrict = member.district_id || '';
                }

                if (this.selectedDistrict) {
                    const zoneResponse = await UserService.authPostRequest('get-zone-by-id', { district_id: this.selectedDistrict });
                    if (zoneResponse.data.status === 'success') {
                        this.zone_list = zoneResponse.data.data.list;
                        this.selectedZone = member.zone_id || '';
                    }
                }

                if (this.selectedZone) {
                    const unitResponse = await UserService.authPostRequest('get-unit-by-id', { zone_id: this.selectedZone });
                    if (unitResponse.data.status === 'success') {
                        this.unit_list = unitResponse.data.data.list;
                        this.selectedUnit = member.unit_id || '';
                    }
                }
            } catch (error) {
                this.alert_type = 'Error';
                this.alert_message = error.message || 'An error occurred while fetching data.';
                this.$refs.alert_model.openModel();
            }
        },
        onDistrictChange() {
            this.getZoneList(this.selectedDistrict);
        },
        onZoneChange() {
            this.getUnitList(this.selectedZone);
        },
        submitChangeUnit() {
            if (!this.selectedUnit || !this.changeUnitForm.reason) return;
            this.loading = true;
            const data = {
                member_id: this.changeUnitForm.member_id,
                unit_id: this.selectedUnit,
                reason: this.changeUnitForm.reason
            };
            UserService.authPostRequest('change-member-unit', data).then((response) => {
                this.loading = false;
                if (response.data.status === 'success') {
                    $('#changeUnitModal').modal('hide');
                    this.alert_type = 'Success';
                    this.alert_message = response.data.message;
                    this.$refs.alert_model.openModel();
                    this.getMembersList(this.wing);
                } else {
                    this.alert_type = 'Error';
                    this.alert_message = response.data.message;
                    this.$refs.alert_model.openModel();
                }
            }, (error) => {
                this.loading = false;
                this.alert_type = 'Error';
                this.alert_message = error.message || 'An error occurred';
                this.$refs.alert_model.openModel();
            });
        },

        approveUnitChange(member) {
            this.$swal.fire({
                title: 'Approve Unit Transfer',
                text: `Are you sure you want to approve the unit transfer for ${member.name}?`,
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#28a745',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, Approve!'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.processUnitChangeAction(member.id, 'approve');
                }
            });
        },

        rejectUnitChange(member) {
            this.$swal.fire({
                title: 'Reject Unit Transfer',
                text: `Are you sure you want to reject the unit transfer for ${member.name}?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#dc3545',
                cancelButtonColor: '#6c757d',
                confirmButtonText: 'Yes, Reject!'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.processUnitChangeAction(member.id, 'reject');
                }
            });
        },

        processUnitChangeAction(memberId, action) {
            this.loading = true;
            const data = {
                member_id: memberId,
                action: action
            };

            UserService.authPostRequest('change-member-unit-approval', data).then(
                (response) => {
                    this.loading = false;
                    if (response.data.status === 'success') {
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.getMembersList(this.wing);
                    } else {
                        this.alert_type = 'Error';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                    }
                },
                (error) => {
                    this.loading = false;
                    this.alert_type = 'Error';
                    this.alert_message = error.message || 'An error occurred';
                    this.$refs.alert_model.openModel();
                }
            );
        },
    },
};
</script>
<style scoped>
.section-heading {
    padding: 10px 10px 0px 10px;
}

.error-feedback {
    color: red;
}


.edit-btn {
    margin-left: 8px;
}

.progress {
    width: 80px;
}

.listview>li footer {
    color: #171617;
}

.min-width-50 {
    min-width: 60% !important;
}

.action-button-list>li {
    min-height: 1px !important;
}

.sl-no {
    font-weight: 900;
    margin-right: 12px;
}

.deleted-list-title {
    font-size: 15px;
}

.deleted-list {
    margin-bottom: 20px;
}

.deleted-info {
    background-color: #f2bbca;
    font-size: 12px;
}

.deleted-info strong {
    font-size: 18px;
    font-weight: 600;
}

.image-listview.text>li:after {
    left: 0px;
    /* height: 1px; */
    background-color: #1a418c;
}

.verification-badge {
    margin-left: 5px;
}

.avatar-section .button {
    color: #fff;
    width: 18px;
    height: 18px;
    border-radius: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    position: absolute;
    right: 10px;
    top: 24px;
    bottom: 0;
}

.avatar-section .verified {
    background: #4dc81c;
}

.avatar-section .not-verified {
    background: #eb3941;
}

.avatar-section .abroad {
    background: #0962d2;
}

.green-tick {
    font-size: 18px;
    color: darkgreen;
}

.red-cross {
    font-size: 18px;
    color: red;
}

.qhls-text {
    font-style: italic;
    color: #266bd1;
}

.stat-box {
    background: #ffffff;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.09);
    border-radius: 10px;
    padding: 10px 10px;
}

.tab-container-1 {
    display: flex;
    justify-content: center;
    margin: 1.5rem 0 1rem 0;
}

.pill-tabs {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    max-width: 600px;
    margin: 0 auto;
}

.pill-tab {
    flex: 1 1 140px;
    min-width: 120px;
    max-width: 200px;
    padding: 0.6rem 1rem;
    border: none;
    border-radius: 999px;
    background: #f5f7fa;
    color: #1a418c;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.18s, color.18s, box-shadow 0.18s;
    outline: none;
    box-shadow: 0 1px 3px rgba(26, 65, 140, 0.04);
    margin: 0;
    text-align: center;
    white-space: nowrap;
}

.pill-tab.active,
.pill-tab:focus {
    background: #1a418c;
    color: #fff;
    font-weight: bold;
    box-shadow: 0 2px 8px rgba(26, 65, 140, 0.10);
}



@media (max-width: 800px) {
    .pill-tabs {
        max-width: 100%;
        gap: 0.7rem;
    }

    .pill-tab {
        flex: 1 1 110px;
        font-size: 0.98rem;
        padding: 0.5rem 0.7rem;
    }
}

@media (max-width: 500px) {
    .pill-tabs {
        gap: 0.5rem;
    }

    .pill-tab {
        flex: 1 1 90px;
        font-size: 0.95rem;
        padding: 0.45rem 0.5rem;
    }
}

.avatar-section .button-payment {
    color: #fff;
    width: 18px;
    height: 18px;
    border-radius: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    position: absolute;
    right: 10px;
    top: 5px;
    bottom: 0;
}

.avatar-section .payment-verified {
    background: #05d0a4;
}

.action .btn-sm {
    height: auto;
    width: 100%;
}
</style>